import React, { useState } from "react";

import "bootstrap/dist/css/bootstrap.min.css";
import "../assets/css/style.css";
import ImportantToKnow from "../components/ImportantToKnow";
import api from "../api/Api.js";
import modifycarImage from "../assets/images/bg1.jpg";
import { useLanguage } from "../context/LanguageContext";

const ModifyReservation = () => {
  const { language, t } = useLanguage();

  const [formData, setFormData] = useState({
    operationType: "0",
    referenceCode: "",
    email: "",
    details: "",
  });

  const [loading, setLoading] = useState(false);

  // =====================================================
  // GET LANGUAGE ID
  // =====================================================

  const getLanguageId = () => {
    if (language && typeof language === "object") {
      return (
        Number(language.lang_id || language.language_id || language.id) || 1
      );
    }
    return Number(language) || 1;
  };

  const languageId = getLanguageId();

  // ============================================================
  // HANDLE INPUT
  // ============================================================

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // ============================================================
  // VALIDATE EMAIL
  // ============================================================

  const isValidEmail = (email) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };

  // ============================================================
  // SUBMIT
  // ============================================================

  const handleSubmit = async (e) => {
    e.preventDefault();

    const referenceCode = formData.referenceCode.trim();
    const email = formData.email.trim();
    const details = formData.details.trim();

    if (!referenceCode) {
      alert(
        t("modifypage.modifypage0", "Please enter booking reference code.")
      );
      return;
    }

    if (!email) {
      alert(t("modifypage.modifypage1", "Please enter email address."));
      return;
    }

    if (!isValidEmail(email)) {
      alert(
        t("modifypage.modifypage2", "Please enter a valid email address.")
      );
      return;
    }

    if (!details) {
      alert(
        t(
          "modifypage.modifypage3",
          "Please enter modification/cancellation details."
        )
      );
      return;
    }

    if (loading) {
      return;
    }

    try {
      setLoading(true);

      const response = await api.post("/reservations/modify", {
        operationType: formData.operationType,
        referenceCode,
        email,
        details,
      });

      const result = response.data;

      if (result.success) {
        alert(
          result.message ||
            t(
              "modifypage.modifypage4",
              "Your modification request submitted."
            )
        );

        setFormData({
          operationType: "0",
          referenceCode: "",
          email: "",
          details: "",
        });

        return;
      }

      alert(
        result.message ||
          t(
            "modifypage.modifypage5",
            "Unable to submit modification request."
          )
      );
    } catch (error) {
      console.error("MODIFY RESERVATION ERROR:", error);

      alert(
        error.response?.data?.message ||
          t(
            "modifypage.modifypage5",
            "Unable to submit modification request."
          )
      );
    } finally {
      setLoading(false);
    }
  };



  // ============================================================
  // RETURN
  // ============================================================

  return (
    <>
      {/* ================= HERO ================= */}
      <div className="bg-box ">
        <section className="modify2 modify1 professional-faq-hero">
          <div className="professional-faq-overlay"></div>

          <div className="container">
            <div className="professional-faq-hero-content">
              <span className="faq-eyebrow">
                {t("menu.menu10", "CRETE HOLIDAYS")}
              </span>

              <h1>{t("menu.menu3", "Modify Reservation")}</h1>

              <p>
                {t(
                  "othersnewstatics.othersnewstatic22",
                  "Everything you need to know about renting a car and enjoying your holiday in Crete."
                )}
              </p>
            </div>
          </div>
        </section>
      </div>

      <div className="p20">
        <div className="p0 container container2">
          {/* ================= LEFT SIDEBAR ================= */}
          <div className="col-md-4 sidebar no1" style={{ float: "left" }}>
            <div className="car-box price-box">
              <img
                src={modifycarImage}
                alt={t("menu.menu3", "Modify Reservation")}
                className="car-img"
              />
            </div>

            <div className="clearfix"></div>
          </div>

          {/* ================= MAIN CONTENT ================= */}
          <div className="col-md-8 main-content" style={{ float: "left" }}>
            <div className="rate">
              {t("menu.menu3", "Modify Reservation")} :
            </div>

            <div className="price-box" style={{ padding: "0px" }}>
              <div className="rate-box">
                <div className="proso" style={{ padding: "30px" }}>
                  <form
                    name="frmModRev"
                    id="frmModRev"
                    onSubmit={handleSubmit}
                    autoComplete="off"
                  >
                    <div className="c-box-left box-line">
                      {/* OPERATION TYPE */}
                      <div
                        className="col-lg-4 form-group mr-2"
                        style={{ float: "left" }}
                      >
                        <div className="p-line ht">
                          {t("modify.modify2", "Operation type")} :
                          <span
                            style={{ color: "#f95d2d", fontWeight: "normal" }}
                          >
                            *
                          </span>
                        </div>

                        <div className="p-line1">
                          <select
                            name="operationType"
                            id="selTitle"
                            className="verysmallfrmtxtbox"
                            value={formData.operationType}
                            onChange={handleChange}
                            disabled={loading}
                          >
                            <option value="0">
                              {t("modify.modify0", "MODIFY")}
                            </option>

                            <option value="1">
                              {t("modify.modify1", "CANCEL")}
                            </option>
                          </select>
                        </div>
                      </div>

                      {/* BOOKING REFERENCE */}
                      <div
                        className="col-lg-4 form-group mr-2"
                        style={{ float: "left" }}
                      >
                        <div className="p-line ht">
                          {t(
                            "modify.modify3",
                            "Booking reference code"
                          )}{" "}
                          :
                          <span
                            style={{ color: "#f95d2d", fontWeight: "normal" }}
                          >
                            *
                          </span>
                        </div>

                        <div className="p-line1">
                          <input
                            type="text"
                            name="referenceCode"
                            id="referenceCode"
                            className="frmtxtbox1"
                            maxLength="30"
                            value={formData.referenceCode}
                            onChange={handleChange}
                            disabled={loading}
                          />
                        </div>
                      </div>

                      {/* EMAIL */}
                      <div
                        className="col-lg-4 form-group mr-2"
                        style={{ float: "left" }}
                      >
                        <div className="p-line ht">
                          {t("modify.modify4", "Email id")} :
                          <span
                            style={{ color: "#f95d2d", fontWeight: "normal" }}
                          >
                            *
                          </span>
                        </div>

                        <div className="p-line1">
                          <input
                            type="email"
                            name="email"
                            id="txtconfirmemail"
                            className="frmtxtbox1"
                            maxLength="70"
                            value={formData.email}
                            onChange={handleChange}
                            disabled={loading}
                          />
                        </div>
                      </div>

                      <div className="clearfix"></div>

                      {/* DETAILS */}
                      <div
                        className="col-lg-12 form-group mr-2"
                        style={{ float: "left" }}
                      >
                        <div className="p-line ht">
                        {t("modify.modify9", "Modify/Cancellation details")} :
                          <span
                            style={{ color: "#f95d2d", fontWeight: "normal" }}
                          >
                            *
                          </span>
                        </div>

                        <div className="p-line1">
                          <textarea
                            name="details"
                            className="frmtxtarea"
                            rows="5"
                            cols="13"
                            style={{
                              width: "100%",
                              height: "74px",
                              padding: "8px 12px",
                            }}
                            value={formData.details}
                            onChange={handleChange}
                            disabled={loading}
                            placeholder={`${t("modify.modify9", "Modify/Cancellation details")}...`}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="clearfix"></div>

                    {/* BOTTOM SECTION */}
                    <div
                      className="col-lg-12 form-group mr-2"
                      style={{ float: "left" }}
                    >
                      <div className="yes">
                        <div
                          className="termlink"
                          style={{ backgroundColor: "#FFFFFF" }}
                        >
                          <label>
                            <span style={{ color: "red" }}>**</span>

                            <strong>
                              {" "}
                              {t(
                                "modifypage.modifypage5",
                                "You can modify your booking the latest"
                              )}
                              &nbsp;
                                 3 {t(
                                "bookingengine.bookingengine21",
                                "day(s)"
                              )}                  
                              &nbsp;
                              {t(
                                "modifypage.modifypage7",
                                "before your pick-up date"
                              )}
                            </strong>
                          </label>

                          <div className="clearfix"></div>
                        </div>
                      </div>

                      {/* BUTTON */}
                      <div className="yes1" style={{ float: "right" }}>
                        <input
                          name="btnpersonaldtlssubmit"
                          id="btnpersonaldtlssubmit"
                          type="submit"
                          className="nextbutton1 nextbutton2"
                          value={
                            loading
                              ?`${t("modifypage.modifypage8", "Proceed")}...`
                              : t("modifypage.modifypage8", "Proceed")
                          }
                          disabled={loading}
                        />
                      </div>
                    </div>
                  </form>

                  <div className="clearfix"></div>
                </div>
              </div>

              <div className="clearfix"></div>
            </div>

            <div className="clearfix"></div>
          </div>

          <div className="clearfix"></div>
        </div>

        <ImportantToKnow />
      </div>
    </>
  );
};

export default ModifyReservation;